import { render, staticRenderFns } from "./DownloadResourceDefinitionMaintain.vue?vue&type=template&id=05a402e4"
import script from "./DownloadResourceDefinitionMaintain.vue?vue&type=script&lang=js"
export * from "./DownloadResourceDefinitionMaintain.vue?vue&type=script&lang=js"
import style0 from "./DownloadResourceDefinitionMaintain.vue?vue&type=style&index=0&id=05a402e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports